import Query from 'library/util/query';
import { jsonToInputParams } from 'library/util/graph';

const questionsQuery = async (
  questionSet = 'user_profile_steps',
  includeAnswered = true,
  uuid
) => {
  const params = {
    question_set: questionSet,
    include_answered: includeAnswered,
  };
  if (uuid) params.uuid = uuid;

  return await Query(`
    query {
      questions (${jsonToInputParams(params)}) {
        id
        attribute_to_update
        model_to_update
        text
        render_type
        question_group_id
        answer_choices {
          id
          key
          value
          metadata
        }
        user_response {
          string_response
          selected_answer_choices {
            id
            key
            value
          }
        }
      }
    }
  `);
};

export default questionsQuery;
